<template>
  <div class="rightModal">
    <InfoBox>
      <ul>
        <li class="mb-2">{{ $t('popups.detachFromServer.infoText1') }}</li>
        <li class="mb-2">{{ $t('popups.detachFromServer.infoText2') }}</li>
        <li class="mb-2">{{ $t('popups.detachFromServer.infoText3') }}</li>
        <li class="mb-2">{{ $t('popups.detachFromServer.infoText4') }}</li>
      </ul>
    </InfoBox>

    <div
      class="info mb-3"
      v-for="(item, index) in virtualMachines"
      :key="item.id"
    >
      <div class="mb-2">
        <b>{{ $t('global.name') }} : </b> {{ item.name }}
      </div>
      <div class="mb-2">
        <b>{{ $t('global.device') }} : </b> {{ index++ }}
      </div>
      <div>
        <b>{{ $t('global.size') }} : </b>
        {{ $customFunctions.convertMBtoGB(item.total_disk) }} GB
      </div>
    </div>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'DetachFromServer',
  props: {
    confirmModal: Boolean,
    selectedId: String,
    virtualMachines: {
      type: Array,
      default: [],
    },
  },
  methods: {
    confirm() {
      ApiService.delete(
        `iaas/virtual-disk-images/${this.selectedId}/detach/${
          this.virtualMachines.length > 0 ? this.virtualMachines[0].id : 0
        }?force=0`
      )
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
